import styled from 'styled-components'

const SolutionListingStyle = styled.section`
	--descColWidth: 50%;
	--descColDistance: var(--sp9x);
	--infoWrapMTop: var(--sp10x);
	--iconsWrapMTop: var(--sp9x);
	--iconSize: var(--sp8x);
	--iconDistance: var(--sp3x);

	--arrowWrapWidth: var(--sp6x);
	--arrowWrapBottom: var(--sp5x);
	--arrowWrapPrevRight: var(--sp15x);
	--arrowWrapNextRight: var(--sp5x);
	--iconSizes: var(--sp2x);
	--sliderImage: 50.4%;

	--pointTextMaxWidth: 74%;

	.itemTextWrap {
		margin-top: var(--sectionsDistance);
	}

	.sol-item {
		margin-bottom: var(--sectionsDistance);

		.infoWrap {
			margin-top: var(--infoWrapMTop);

			.descWrap {
				display: flex;
				flex-wrap: wrap;
				margin-left: calc(-1 * calc(var(--descColDistance) / 2));
				margin-right: calc(-1 * calc(var(--descColDistance) / 2));

				.descCol {
					width: var(--descColWidth);
					padding: 0 calc(var(--descColDistance) / 2);
				}
			}

			.iconsWrap {
				margin-top: var(--iconsWrapMTop);
				margin-bottom: var(--sectionsDistance);

				.pointItemWrap {
					.imageCont {
						width: var(--iconSize);
						height: var(--iconSize);
						padding-top: 0;
						margin-bottom: var(--iconDistance);
					}

					.maxWidthStyle {
						max-width: var(--pointTextMaxWidth);
					}
				}
			}
		}

		.sliderCont {
			position: relative;

			.gallerySlider {
				position: relative;

				.slider-image {
					padding-top: var(--sliderImage);
				}

				.swiper-pagination {
					position: absolute;
					left: var(--arrowWrapNextRight);
					bottom: var(--arrowWrapBottom);
					z-index: 1;
					font-size: var(--p);
					font-family: Montserratarm;
					font-weight: 400;
					width: fit-content;
					color: var(--primaryColor1);
				}

				.arrow-wrap-next {
					position: absolute;
					right: var(--arrowWrapNextRight);
					bottom: var(--arrowWrapBottom);
					display: flex;
					justify-content: center;
					align-items: center;
					width: var(--arrowWrapWidth);
					height: var(--arrowWrapWidth);
					border: 2px solid var(--primaryColor1);
					border-radius: 50%;
					z-index: 1;
					transition: var(--trTime);
					cursor: pointer;

					@media (hover: hover) {
						&:hover {
							transform: scale(1.1);
						}
					}

					&.swiper-button-disabled {
						opacity: 0.5;
						pointer-events: none;
					}

					.slider-gallery-next {
						transform: rotate(45deg);
						font-size: var(--iconSizes);
					}
				}

				.arrow-wrap-prev {
					position: absolute;
					right: var(--arrowWrapPrevRight);
					bottom: var(--arrowWrapBottom);
					display: flex;
					justify-content: center;
					align-items: center;
					width: var(--arrowWrapWidth);
					height: var(--arrowWrapWidth);
					border: 2px solid var(--primaryColor1);
					border-radius: 50%;
					z-index: 1;
					transition: var(--trTime);
					cursor: pointer;

					@media (hover: hover) {
						&:hover {
							transform: scale(1.1);
						}
					}

					&.swiper-button-disabled {
						opacity: 0.5;
						pointer-events: none;
					}

					.slider-gallery-prev {
						transform: rotate(-135deg);
						font-size: var(--iconSizes);
					}
				}
			}
		}
	}

	.black-layer {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: var(--primaryColor2);
		z-index: 100;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeL}) {
		--infoWrapMTop: var(--sp8x);
		--descColDistance: var(--sp7x);
		--iconsWrapMTop: var(--sp7x);
		--iconSize: var(--sp7x);
		--iconDistance: var(--sp2x);

		--arrowWrapWidth: var(--sp5x);
		--arrowWrapBottom: var(--sp4x);
		--arrowWrapPrevRight: var(--sp12x);
		--arrowWrapNextRight: var(--sp4x);
		--iconSizes: var(--sp1-5x);
		--sliderImage: 50.5%;

		--pointTextMaxWidth: 75%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--infoWrapMTop: var(--sp5x);
		--descColDistance: var(--sp5x);
		--iconsWrapMTop: var(--sp5x);
		--iconSize: var(--sp6x);
		--iconDistance: var(--sp2x);

		--arrowWrapWidth: var(--sp5x);
		--arrowWrapBottom: var(--sp4x);
		--arrowWrapPrevRight: var(--sp12x);
		--arrowWrapNextRight: var(--sp4x);
		--iconSizes: var(--sp1-5x);
		--sliderImage: 50.2%;

		--pointTextMaxWidth: 83%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--infoWrapMTop: var(--sp5x);
		--descColDistance: var(--sp5x);
		--iconsWrapMTop: var(--sp5x);
		--iconSize: var(--sp6x);
		--iconDistance: var(--sp2x);

		--arrowWrapWidth: var(--sp5x);
		--arrowWrapBottom: var(--sp4x);
		--arrowWrapPrevRight: var(--sp12x);
		--arrowWrapNextRight: var(--sp4x);
		--iconSizes: var(--sp1-5x);
		--sliderImage: 50.3%;

		--pointTextMaxWidth: 83%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeXS}) {
		--infoWrapMTop: var(--sp5x);
		--descColDistance: var(--sp5x);
		--iconsWrapMTop: var(--sp5x);
		--iconSize: var(--sp5x);
		--iconDistance: var(--sp2x);

		--arrowWrapWidth: var(--sp4x);
		--arrowWrapBottom: var(--sp3x);
		--arrowWrapPrevRight: var(--sp10x);
		--arrowWrapNextRight: var(--sp3x);
		--iconSizes: var(--sp1x);
		--sliderImage: 50.4%;

		--pointTextMaxWidth: 94%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		--infoWrapMTop: var(--sp4x);
		--descColDistance: var(--sp4x);
		--iconsWrapMTop: var(--sp4x);
		--iconSize: var(--sp5x);
		--iconDistance: var(--sp2x);

		--arrowWrapWidth: var(--sp4x);
		--arrowWrapBottom: var(--sp3x);
		--arrowWrapPrevRight: var(--sp10x);
		--arrowWrapNextRight: var(--sp3x);
		--iconSizes: var(--sp1x);
		--sliderImage: 50.5%;

		--pointTextMaxWidth: 110%;

		.sol-item {
			.infoWrap {
				.iconsWrap {
					.pointItemWrap {
						.maxWidthStyle {
							min-width: var(--pointTextMaxWidth);
							max-width: unset;
						}
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSizeS}) {
		--infoWrapMTop: var(--sp4x);
		--descColDistance: var(--sp4x);
		--iconsWrapMTop: var(--sp4x);
		--iconSize: var(--sp5x);
		--iconDistance: var(--sp2x);

		--arrowWrapWidth: var(--sp4x);
		--arrowWrapBottom: var(--sp3x);
		--arrowWrapPrevRight: var(--sp10x);
		--arrowWrapNextRight: var(--sp3x);
		--iconSizes: var(--sp1x);
		--sliderImage: 50.5%;

		--pointTextMaxWidth: 94%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--descColWidth: 100%;
		--infoWrapMTop: var(--sp3x);
		--descColDistance: var(--sp2x);
		--iconsWrapMTop: var(--sp3x);
		--iconSize: var(--sp5x);
		--iconDistance: var(--sp2x);

		--arrowWrapWidth: var(--sp4x);
		--arrowWrapBottom: var(--sp2x);
		--arrowWrapPrevRight: var(--sp8x);
		--arrowWrapNextRight: var(--sp2x);
		--iconSizes: var(--sp1x);
		--sliderImage: 50.6%;

		--pointTextMaxWidth: 80%;

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.MobileSizeMin}) {
			--pointTextMaxWidth: 45%;
		}

		.sol-item {
			.infoWrap {
				.descWrap {
					.descCol:nth-child(1) {
						margin-bottom: var(--descColDistance);
					}
				}

				.iconsWrap {
					.pointItemWrap {
						&:nth-child(3),
						&:nth-child(4) {
							margin-top: var(--sp3x);
						}
					}
				}
			}
		}
	}
`

export default SolutionListingStyle
